import { Injectable, Injector } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, EMPTY, throwError, catchError } from 'rxjs';
import { SsbdHttp503Handler } from '@app/services/ssbd-http-503.handler';
import { SSBD_HTTP_503, SSBD_HTTP_503_MICRO_BASES } from '@app/constants/ssbd-http-503.constant';

@Injectable()
export class SsbdHttp503Interceptor implements HttpInterceptor {
  constructor(private readonly injector: Injector) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.status === SSBD_HTTP_503.HTTP_STATUS && this.isMicroservice(req.url)) {
          this.injector.get(SsbdHttp503Handler).handleIfHttp503(error, {
            url: req.url,
            method: req.method,
          });
          return EMPTY;
        }
        return throwError(() => error);
      })
    );
  }

  private isMicroservice(url: string): boolean {
    return SSBD_HTTP_503_MICRO_BASES.some((base) => url.includes(base));
  }
}
